import { supabase } from '../../common/config/supabase';
import { PDFStaticBuilderProps } from '../../common/helpers/pdf-builder';
import { IClientCertificate } from '../../common/interfaces/client-certificate.interface';

export const getClientCertificate = async (client_id?: string): Promise<IClientCertificate> => {
  const { data, error } = await supabase
    .from('client_certificate')
    .select('*,  clients(companies(name))')
    .eq('client_id', client_id)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data;
};

export const updateClientCertificate = async (
  clientCertificateId: number | undefined,
  client_id: number,
  config: PDFStaticBuilderProps,
): Promise<IClientCertificate> => {
  const { data, error } = await supabase
    .from('client_certificate')
    .upsert({ client_id, config }, { onConflict: 'client_id' })
    .eq('id', clientCertificateId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
